gsap.registerPlugin(ScrollTrigger);
// animateTitlesLeftToRight();
smoothScroller();
anchorScroll();
initHamburger();

materialsAccordion();
materialsTabs();
materialsSidebar();

// sparks();

dshvPopup();
videoPopup();

parallaxHero();

function animateTitlesLeftToRight() {
  // Знаходимо всі елементи з класом .title-reveal
  const titles = document.querySelectorAll(".title-reveal");

  if (titles.length === 0) return;

  titles.forEach((title) => {
    gsap.fromTo(
      title,
      {
        opacity: 0,
        x: -100, // Починає рух зі зміщенням 100px вліво
      },
      {
        opacity: 1,
        x: 0, // Повертається на своє рідне місце
        duration: 1.2, // Тривалість появи
        ease: "power3.out", // Дуже плавне гальмування в кінці
        scrollTrigger: {
          trigger: title,
          start: "top 85%", // Анімація стартує, коли заголовок з'являється на 85% висоти екрана знизу
          toggleActions: "play none none none", // Програється один раз.
          // Якщо хочеш, щоб анімація повторювалась при скролі туди-сюди, заміни на "play none none reverse"
        },
      },
    );
  });
}

function smoothScroller() {
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
    autoRaf: true,
  });
  lenis.on("scroll", ScrollTrigger.update);
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });
  gsap.ticker.lagSmoothing(0);
  window.lenis = lenis;
}

function sparks() {
  const sparkSvgTemplate = `
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 365">
    <defs>
      <linearGradient id="linear-gradient" x1="-45.4" y1="113.33" x2="152.21" y2="337.78" gradientUnits="userSpaceOnUse">
        <stop offset="0.01" stop-color="#c1272d" />
        <stop offset="0.32" stop-color="red" />
        <stop offset="0.74" stop-color="#fcee21" />
        <stop offset="1" stop-color="#f6dfde" />
        <stop offset="1" stop-color="#fff" />
      </linearGradient>
      <linearGradient id="linear-gradient-2" x1="48" y1="200.5" x2="79" y2="200.5" gradientUnits="userSpaceOnUse">
        <stop offset="0" />
        <stop offset="1" stop-color="#fff" />
      </linearGradient>
    </defs>
    <rect fill="url(#linear-gradient)" width="31" height="365" rx="15.5" />
    <path fill="url(#linear-gradient-2)" d="M63.5,19A14.51,14.51,0,0,1,78,33.5v334a14.5,14.5,0,0,1-29,0V33.5A14.51,14.51,0,0,1,63.5,19m0-1A15.5,15.5,0,0,0,48,33.5v334a15.5,15.5,0,0,0,31,0V33.5A15.5,15.5,0,0,0,63.5,18Z" transform="translate(-48 -18)" />
  </svg>
`;

  const containerSparks = document.getElementById("main");

  // Перевіряємо наявність контейнера, щоб не було помилок на інших сторінках
  if (containerSparks) {
    let w = window.innerWidth;
    let h = window.innerHeight;
    const total = 100;
    const particles = [];

    function R(min, max) {
      return min + Math.random() * (max - min);
    }

    for (let i = 0; i < total; i++) {
      const el = document.createElement("div");
      el.className = "spark";
      el.innerHTML = sparkSvgTemplate;
      containerSparks.appendChild(el);

      particles.push({
        el: el,
        x: R(0, w),
        y: R(h, h + 200),
        speedY: R(3, 15),
        windForce: R(-0.5, 5.5),
        swayAmp: R(5, 15),
        swaySpeed: (Math.PI * 2) / R(2, 5),
        swayOffset: R(0, Math.PI * 2),
        rotZ: R(-10, 10),
        scale: R(0.2, 0.9),
      });
    }

    let lastTime = performance.now();

    function executeAnimation(time) {
      const deltaTime = (time - lastTime) / 1000;
      lastTime = time;
      const speedMultiplier = deltaTime * 60;
      const globalWind = Math.sin(time / 4000) * 1.5;

      particles.forEach((p) => {
        p.y -= p.speedY * speedMultiplier;
        p.x += (globalWind + p.windForce) * speedMultiplier;

        if (p.x > w + 50) p.x = -50;
        else if (p.x < -50) p.x = w + 50;

        if (p.y < -150) {
          p.y = h + R(10, 200);
          p.x = R(0, w);
        }

        const currentX =
          p.x +
          Math.sin((time / 1000) * p.swaySpeed + p.swayOffset) * p.swayAmp;
        const dynamicRotZ = p.rotZ + globalWind * 15;

        p.el.style.transform = `translate(${currentX}px, ${p.y}px) rotate(${dynamicRotZ}deg) scale(${p.scale})`;
      });

      requestAnimationFrame(executeAnimation);
    }

    window.addEventListener("resize", () => {
      w = window.innerWidth;
      h = window.innerHeight;
    });

    requestAnimationFrame(executeAnimation);
  }
}

function initHamburger() {
  const hamburgerActive = document.querySelectorAll(".hamburger-close");
  const hamburgerBtn = document.querySelector(".hamburger__btn");
  const overlayId = document.getElementById("overlay");

  hamburgerActive.forEach((activeBtn) => {
    activeBtn.addEventListener("click", () => {
      overlayId.classList.toggle("open");
      hamburgerBtn.classList.toggle("open");
      document.body.classList.toggle("overflow");
    });
  });

  const menuItems = document.querySelectorAll(
    ".hamburger__overlay-list_item-link",
  );
  const currentPath = window.location.pathname;

  menuItems.forEach((item) => {
    if (item.getAttribute("href") === currentPath) {
      item.classList.add("active");
    }
  });
}

function anchorScroll() {
  const anchorLinks = document.querySelectorAll('a[href^="#"]');

  anchorLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      const href = this.getAttribute("href");
      if (href === "#") return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const targetOffset =
          target.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({
          top: targetOffset,
          behavior: "smooth",
        });
      }
    });
  });
}

function materialsAccordion() {
  const folders = document.querySelectorAll(".file-tree__folder");

  folders.forEach((folder) => {
    folder.addEventListener("click", function () {
      // Перемикаємо клас для самої папки (наприклад, щоб змінити іконку)
      this.classList.toggle("file-tree__folder--open");

      // Знаходимо наступний елемент (це завжди наш <ul class="file-tree__sub">)
      const subList = this.nextElementSibling;

      if (subList && subList.classList.contains("file-tree__sub")) {
        // Відкриваємо або закриваємо список
        if (subList.style.display === "block") {
          subList.style.display = "none";
        } else {
          subList.style.display = "block";
        }
      }
    });
  });
}

function materialsTabs() {
  const container = document.querySelector(".study-tabs-ui");
  if (!container) return;

  const tabs = container.querySelectorAll(".study-tabs__tab");
  const panes = container.querySelectorAll(".study-tabs__pane");
  const navBtns = container.querySelectorAll(".study-tabs__btn-nav");

  // Логіка перемикання табів
  function switchTab(index) {
    tabs.forEach((t) => t.classList.remove("study-tabs__tab--active"));
    panes.forEach((p) => p.classList.remove("study-tabs__pane--active"));

    const targetTab = container.querySelector(
      `.study-tabs__tab[data-tab="${index}"]`,
    );
    const targetPane = document.getElementById(`study-pane-${index}`);

    if (targetTab && targetPane) {
      targetTab.classList.add("study-tabs__tab--active");
      targetPane.classList.add("study-tabs__pane--active");
    }
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      switchTab(this.getAttribute("data-tab"));
    });
  });

  navBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      switchTab(this.getAttribute("data-target"));
    });
  });

  // Логіка акордеона
  container.querySelectorAll(".study-tabs__acc-head").forEach((head) => {
    // Уникаємо подвійних кліків, якщо скрипт викликається кілька разів
    head.replaceWith(head.cloneNode(true));
  });

  container.querySelectorAll(".study-tabs__acc-head").forEach((head) => {
    head.addEventListener("click", function (e) {
      e.preventDefault();

      this.classList.toggle("active");
      const arrow = this.querySelector(".study-tabs__arrow");

      // Оскільки тепер кнопка і список лежать поруч всередині <li>,
      // ми шукаємо сусідній елемент (список файлів)
      const list = this.nextElementSibling;

      if (
        list &&
        (list.classList.contains("study-tabs__file-list") ||
          list.tagName.toLowerCase() === "ul")
      ) {
        if (list.style.display === "block") {
          list.style.display = "none";
          if (arrow) arrow.style.transform = "rotate(0deg)";
        } else {
          list.style.display = "block";
          if (arrow) arrow.style.transform = "rotate(180deg)";
        }
      }
    });
  });
}

function materialsSidebar() {
  const sidebarTabs = document.querySelectorAll(".study-sidebar__tab");
  const sidebarPanes = document.querySelectorAll(".study-sidebar__pane");

  sidebarTabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      const target = this.dataset.tab;

      sidebarTabs.forEach((t) =>
        t.classList.remove("study-sidebar__tab--active"),
      );
      sidebarPanes.forEach((p) =>
        p.classList.remove("study-sidebar__pane--active"),
      );

      this.classList.add("study-sidebar__tab--active");
      document
        .getElementById("sidebar-pane-" + target)
        .classList.add("study-sidebar__pane--active");

      // Скрол до верху контенту на мобілках
      if (window.innerWidth < 992) {
        document
          .querySelector(".study-sidebar__main")
          .scrollIntoView({ behavior: "smooth" });
      }
    });
  });

  // Акордеон (рекурсивний)
  document.addEventListener("click", function (e) {
    // Шукаємо клік по голові акордеона (будь-якого рівня)
    const head = e.target.closest(".study-sidebar__acc-head");

    if (head) {
      e.preventDefault();
      const list = head.nextElementSibling; // Це наш ul.study-sidebar__file-list

      if (list) {
        const isHidden = window.getComputedStyle(list).display === "none";

        // Перемикаємо видимість
        list.style.display = isHidden ? "block" : "none";

        // Додаємо клас active для розвороту стрілки
        head.classList.toggle("active");
      }
    }
  });
}

function dshvPopup() {
  const overlay = document.getElementById("popupOverlay");
  const openBtns = document.querySelectorAll(".open-popup-btn");
  const closeBtn = document.getElementById("closePopup");
  const form = document.getElementById("applicationForm");

  const togglePopup = (show) => {
    overlay.classList[show ? "add" : "remove"]("active");
    document.body.style.overflow = show ? "hidden" : "";
  };

  openBtns.forEach((btn) =>
    btn.addEventListener("click", () => togglePopup(true)),
  );
  closeBtn.addEventListener("click", () => togglePopup(false));

  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) togglePopup(false);
  });

  // Обробка форми
  // form.addEventListener("submit", (e) => {
  //   e.preventDefault();
  //   const btn = document.getElementById("submitButton");
  //   const loader = btn.querySelector(".loader");
  //   const title = document.getElementById("buttonTitle");

  //   // Візуальний ефект відправки
  //   loader.classList.remove("hideElement");
  //   title.textContent = "ВІДПРАВКА...";
  //   btn.style.pointerEvents = "none";

  //   // Тут твій AJAX запит
  //   setTimeout(() => {
  //     alert("Дякуємо! Ваша анкета отримана.");
  //     form.reset();
  //     loader.classList.add("hideElement");
  //     title.textContent = "ВІДПРАВИТИ";
  //     btn.style.pointerEvents = "all";
  //     togglePopup(false);
  //   }, 2000);
  // });
}

function videoPopup() {
  const openBtns = document.querySelectorAll(".open-video");
  const popup = document.getElementById("video-popup");
  const closeBtn = document.querySelector(".video-popup__close");
  const overlay = document.querySelector(".video-popup__overlay");
  const video = document.getElementById("promo-video");

  if (!popup || !video || openBtns.length === 0) return;

  // 1. Відкрити попап і запустити відео
  openBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault(); // Забороняємо браузеру переходити по href=""
      popup.classList.add("is-active");
      video.currentTime = 0; // Завжди починаємо з початку
      video.play(); // Автоматичний запуск
    });
  });

  // 2. Функція закриття попапу
  const closePopup = () => {
    popup.classList.remove("is-active");
    video.pause(); // ВАЖЛИВО: Ставимо на паузу, щоб не грало у фоні
  };

  // Закриваємо по кліку на хрестик або на темний фон навколо
  closeBtn.addEventListener("click", closePopup);
  overlay.addEventListener("click", closePopup);

  // 3. Закриваємо по кнопці ESC (правило хорошого тону для UX)
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && popup.classList.contains("is-active")) {
      closePopup();
    }
  });
}

function parallaxHero() {
  const mm = gsap.matchMedia();
  mm.add("(min-width: 992px)", () => {
    if (!document.querySelector(".child-page")) return;
    const tlParallax = gsap.timeline({
      scrollTrigger: {
        trigger: ".child-page",
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
    });

    tlParallax.to(
      ".child-page .layer-bg",
      { yPercent: 60, scale: 1.1, ease: "none" },
      0,
    );
    tlParallax.to(
      ".child-page .child-page__title",
      { yPercent: 200, ease: "none" },
      0,
    );
    tlParallax.to(
      ".child-page .layer-logo",
      { yPercent: 100, scale: 0.9, ease: "none" },
      0,
    );
    tlParallax.to(
      ".child-page .layer-soldier-L",
      { yPercent: 80, xPercent: -4, ease: "none" },
      0,
    );
    tlParallax.to(
      ".child-page .layer-soldier-M",
      { yPercent: 80, ease: "none" },
      0,
    );
    tlParallax.to(
      ".child-page .layer-soldier-R",
      { yPercent: 80, xPercent: 10, ease: "none" },
      0,
    );
    tlParallax.to(
      ".child-page .layer-footer", 
      { yPercent: 40, ease: "none" }, 
      0
    );
  });
}